export default __webpack_public_path__ + "static/media/screenshot1.8673b06d.jpg";